import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMultiBarGraph = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24.6661 27.2551L27.1293 27.2551C27.4742 27.2551 27.7451 26.9925 27.7451 26.6584L27.7451 21.8848C27.7451 20.8943 26.9199 20.0947 25.8977 20.0947C24.8754 20.0947 24.0503 20.8943 24.0503 21.8848L24.0503 26.6584C24.0503 26.9925 24.3212 27.2551 24.6661 27.2551ZM26.5135 26.0617L25.2819 26.0617L25.2819 21.8848C25.2819 21.5506 25.5528 21.2881 25.8977 21.2881C26.2425 21.2881 26.5135 21.5506 26.5135 21.8848L26.5135 26.0617Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9033 27.2543L21.3666 27.2543C21.7115 27.2543 21.9824 26.9918 21.9824 26.6576L21.9824 14.7237C21.9824 13.7332 21.1572 12.9336 20.135 12.9336C19.1127 12.9336 18.2875 13.7332 18.2875 14.7237L18.2875 26.6576C18.2875 26.9918 18.5585 27.2543 18.9033 27.2543ZM20.7508 26.0609L19.5192 26.0609L19.5192 14.7237C19.5192 14.3896 19.7901 14.127 20.135 14.127C20.4798 14.127 20.7508 14.3896 20.7508 14.7237L20.7508 26.0609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1416 27.2543L15.6049 27.2543C15.9497 27.2543 16.2207 26.9917 16.2207 26.6576L16.2207 17.1104C16.2207 16.1199 15.3955 15.3203 14.3733 15.3203C13.351 15.3203 12.5258 16.1199 12.5258 17.1104L12.5258 26.6576C12.5258 26.9917 12.7968 27.2543 13.1416 27.2543ZM14.989 26.0609L13.7574 26.0609L13.7574 17.1104C13.7574 16.7763 14.0284 16.5137 14.3733 16.5137C14.7181 16.5137 14.989 16.7763 14.989 17.1104L14.989 26.0609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.37794 27.2547L9.8412 27.2547C10.186 27.2547 10.457 26.9921 10.457 26.658L10.457 2.79009C10.457 1.79957 9.63181 1 8.60959 1C7.58733 1 6.76215 1.79957 6.76215 2.79009L6.76215 26.658C6.76215 26.9921 7.03311 27.2547 7.37794 27.2547ZM9.22538 26.0613L7.99376 26.0613L7.99376 2.79009C7.99376 2.45594 8.26472 2.19339 8.60959 2.19339C8.95442 2.19339 9.22538 2.45594 9.22538 2.79009L9.22538 26.0613Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.61622 27.2545L4.07949 27.2545C4.42432 27.2545 4.69531 26.992 4.69531 26.6578L4.69531 7.56354C4.69531 6.57303 3.87009 5.77344 2.84787 5.77344C1.82561 5.77344 1.00043 6.57303 1.00043 7.56354L1.00044 26.6578C1.00044 26.992 1.27139 27.2545 1.61622 27.2545ZM3.46366 26.0612L2.23205 26.0612L2.23205 7.56354C2.23205 7.22939 2.503 6.96684 2.84787 6.96684C3.1927 6.96684 3.46366 7.22939 3.46366 7.56354L3.46366 26.0612Z",
			fill: "currentColor"
		})
	]
});
export default SvgMultiBarGraph;
